import React from "react";
import Fab from "@mui/material/Fab";
import Zoom from "@mui/material/Zoom";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

/**
 * Rendered once, in App. The home page previously mounted one of these inside
 * every skill card, stacking five identical fixed-position buttons on top of
 * each other.
 */
const BackToTopFab = () => {
  const visible = useScrollTrigger({ disableHysteresis: true, threshold: 300 });

  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <Zoom in={visible}>
      <Fab
        size="medium"
        aria-label="Back to top"
        onClick={scrollToTop}
        sx={(theme) => ({
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: theme.zIndex.appBar,
          backgroundColor: theme.tokens.invert.background,
          color: theme.tokens.invert.color,
          "&:hover": {
            backgroundColor: theme.tokens.invert.hoverBackground,
            color: theme.tokens.invert.hoverColor,
          },
        })}
      >
        <ArrowUpwardIcon />
      </Fab>
    </Zoom>
  );
};

export default BackToTopFab;
